import { ActionContext } from 'vuex/types'

interface SnackbarState {
    content: string,
    color: string
}

const getDefaultState = ():SnackbarState => ({
    content: '',
    color: ''
})

const Snackbar = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        showMessage(state: SnackbarState, message: { content: string, color: string }) {
            state.content = message.content
            state.color = message.color
        }    
    },
    actions: {
        setSnackbarMessage({ commit }:ActionContext<SnackbarState, any>, payload: { content: string, color: string }) {
            commit('showMessage', payload)
        }
    }
}

export default Snackbar
